// extracted by mini-css-extract-plugin
export var active = "_ii-2";
export var recordingDot = "_ii-1";
export var recordingIndicator = "_ii-0";